"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@widget-editor/core");

var _fetchLayersHook = _interopRequireDefault(require("./fetch-layers-hook"));

var _legend = _interopRequireDefault(require("./legend"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Chart = _react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../chart"));
  });
});

var Map = _react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("@widget-editor/map"));
  });
});

var Standalone = function Standalone(_ref) {
  var thumbnail = _ref.thumbnail,
      widgetConfig = _ref.widgetConfig,
      changeBbox = _ref.changeBbox,
      interactionEnabled = _ref.interactionEnabled,
      widgetName = _ref.widgetName;

  var _widgetConfig$paramsC, _widgetConfig$paramsC2, _widgetConfig$legend, _widgetConfig$paramsC3;

  var isMap = (widgetConfig === null || widgetConfig === void 0 ? void 0 : (_widgetConfig$paramsC = widgetConfig.paramsConfig) === null || _widgetConfig$paramsC === void 0 ? void 0 : _widgetConfig$paramsC.visualizationType) === "map";

  var _ref2 = (0, _fetchLayersHook["default"])(widgetConfig === null || widgetConfig === void 0 ? void 0 : (_widgetConfig$paramsC2 = widgetConfig.paramsConfig) === null || _widgetConfig$paramsC2 === void 0 ? void 0 : _widgetConfig$paramsC2.layer, isMap),
      _ref3 = _slicedToArray(_ref2, 1),
      _ref3$ = _ref3[0],
      layerData = _ref3$.layerData,
      isLoadingLayers = _ref3$.isLoadingLayers,
      isErrorLayers = _ref3$.isErrorLayers;

  if (isLoadingLayers) {
    return "Loading...";
  }

  if (isErrorLayers) {
    return "Error loading widget...";
  }

  var wConfig = widgetConfig || {};
  wConfig.autosize = {
    type: "fit",
    contains: "padding"
  };
  wConfig.width = wConfig.width || 400;
  wConfig.height = wConfig.height || 500;
  wConfig.config = _objectSpread({}, (0, _core.getDefaultTheme)(), {}, wConfig.config ? wConfig.config : {});
  return _react["default"].createElement(_react.Fragment, null, !isMap && _react["default"].createElement(_react.Suspense, null, widgetConfig.hasOwnProperty('legend') && (widgetConfig === null || widgetConfig === void 0 ? void 0 : (_widgetConfig$legend = widgetConfig.legend) === null || _widgetConfig$legend === void 0 ? void 0 : _widgetConfig$legend.length) > 0 && !thumbnail && _react["default"].createElement(_legend["default"], {
    widgetConfig: widgetConfig
  }), _react["default"].createElement(Chart, {
    thumbnail: thumbnail,
    standalone: true,
    standaloneConfiguration: wConfig
  })), isMap && _react["default"].createElement(_react.Suspense, null, _react["default"].createElement(Map, {
    layerId: widgetConfig === null || widgetConfig === void 0 ? void 0 : (_widgetConfig$paramsC3 = widgetConfig.paramsConfig) === null || _widgetConfig$paramsC3 === void 0 ? void 0 : _widgetConfig$paramsC3.layer,
    thumbnail: thumbnail,
    widget: {
      attributes: {
        widgetConfig: widgetConfig
      }
    },
    mapConfiguration: {
      lat: widgetConfig.lat || 0,
      lng: widgetConfig.lng || 0,
      bbox: widgetConfig.bbox || 0,
      zoom: widgetConfig.zoom || 2,
      basemap: widgetConfig.basemapLayers || null
    },
    caption: widgetName,
    layers: [layerData],
    changeBbox: changeBbox,
    interactionEnabled: interactionEnabled
  })));
};

var _default = Standalone;
exports["default"] = _default;